import React from "react";
import { BtnEcovest } from "../../component/ecovestonboarding/BtnEcovest";
import { Carousel } from "../../component/ecovestonboarding/Carousel";
import "./style.css";

const EcovestOnboarding = () => {
  return (
    <div className="onboarding-container-app">
      <div className="onboarding-container mx-auto">
      {/* Hero Section */}
      <section className="hero-section position-relative overflow-hidden">
        <div className="hero-video position-absolute w-100 h-100">
          <video autoPlay loop muted className="w-100 h-100 object-fit-cover">
            <source src="https://cdn.pixabay.com/video/2018/10/02/18534-293472901_large.mp4" type="video/mp4"/>
          </video>
        </div>
        <div className="hero-overlay position-absolute w-100 h-100"></div>
        
        <div className="container position-relative">
          <div className="row">
            <div className="col-12">
              <img className="logo-main img-fluid mt-4 mb-5" alt="Logo" src="/assets/images/ecovestonboarding/logo-2.svg" />
            </div>
          </div>
          
          <div className="row">
            <div className="col-lg-7">
              <div className="hero-content text-white mb-5">
                <h1 className="hero-title mb-4">Grow your investments, grow a greener world!</h1>
                <p className="hero-subtitle mb-5">
                  Welcome to Tannit Ecovest, the virtual forest where your green
                  investments cultivate real change. Join the movement and plant
                  virtual trees as you invest in sustainable real estate.
                </p>
                <div className="hero-btn">
                  <BtnEcovest
                    stateProp="one-default"
                    text="Become an Eco-Investor. Plant Your Tree Today!"
                  />
                </div>
              </div>
            </div>
            
            <div className="col-lg-5 d-none d-lg-block">
              <div className="tree-counter position-relative text-center">
                <div className="counter-circle d-flex align-items-center justify-content-center mx-auto">
                  <div className="counter-content">
                    <div className="counter-number">3719</div>
                    <div className="counter-text">
                      planted trees
                      <br />
                      until now!
                    </div>
                  </div>
                  <img className="tree-img-1" alt="Tree" src="/assets/images/ecovestonboarding/pikpng-4-1.png" />
                  <img className="tree-img-2" alt="Tree" src="/assets/images/ecovestonboarding/pikpng-3-1.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Playful Section */}
      <section className="playful-section py-5 position-relative overflow-hidden">
        <div className="container position-relative">
          <div className="row">
            <div className="col-12">
              <div className="playful-content mb-5">
                <h2 className="playful-title text-ecogreen">Playful & Engaging</h2>
                <p className="playful-text text-white">
                  At Tannit, we believe in investing that makes a difference
                </p>
              </div>
            </div>
          </div>
          
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-2">
              <div className="playful-image-container position-relative">
                <div className="circles-animation position-absolute">
                  {[...Array(8)].map((_, i) => (
                    <div key={i} className={`circle circle-${i+1}`}></div>
                  ))}
                </div>
                <img className="img-fluid playful-main-img" alt="Main" src="/assets/images/ecovestonboarding/image-212.png" />
              </div>
            </div>
            <div className="col-lg-6 order-lg-1">
              <div className="what-is-ecovest text-center text-lg-start">
                <img className="logo-mark img-fluid mb-4" alt="Logo mark" src="/assets/images/ecovestonboarding/logo-mark.png" />
                <h3 className="what-is-title text-white mb-4">what's Tannit Ecovest?</h3>
                <p className="what-is-subtitle text-ecogreen mb-4">
                  Invest sustainably, level up your impact.
                </p>
                <p className="what-is-text text-white mb-5">
                  At Tannit, we believe in creating a positive impact that starts
                  with your choices. Introducing Ecovest, a unique program where
                  your real estate investments and platform interactions cultivate
                  a virtual forest and contribute to tangible environmental
                  change.
                </p>
                <BtnEcovest
                  stateProp="two-default"
                  text="Plant tree for impact"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works py-5 position-relative">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="xp-card bg-white p-4 rounded-5 mb-5 mb-lg-0">
                <div className="d-flex align-items-center gap-4">
                  <img className="green-coin img-fluid" alt="Green coin" src="/assets/images/Green-Coin-200-200.png" />
                  <div className="xp-content">
                    <div className="xp-amount text-graymain">8K XP</div>
                    <div className="d-flex align-items-center gap-2">
                      <img className="tree-icon" alt="Tree" src="/assets/images/ecovestonboarding/image-86.png" />
                      <span className="tree-count text-graymain">3</span>
                    </div>
                    <div className="progress-container mt-2">
                      <div className="progress-bar bg-ecogreen"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="how-it-works-content">
                <h3 className="how-it-works-title text-ecogreen mb-4">Grow Your Forest, One Action at a Time!</h3>
                <p className="how-it-works-text text-ecogreen mb-5">
                  Earning the right to plant trees in the Ecovest forest is easy and rewarding. <strong>Here's how it works:</strong>
                </p>
                
                <div className="steps-container">
                  <div className="step-item">
                    <h4 className="step-title text-ecogreen">⭐ Engage & Earn Green Coins:</h4>
                    <p className="step-text text-ecogreen">
                      Earn Green Coins for daily logins, social media shares,
                      sponsoring others, and most importantly, investing in
                      sustainable real estate projects on Tannit.
                    </p>
                  </div>
                  
                  <div className="step-item">
                    <h4 className="step-title text-ecogreen">🚀 Level Up with Experience:</h4>
                    <p className="step-text text-ecogreen">
                      As you interact with the platform, you'll gain
                      experience points (XP). Each level unlocks the ability to
                      plant a specific tree type in the virtual forest.
                    </p>
                  </div>
                  
                  <div className="step-item">
                    <h4 className="step-title text-ecogreen">🧭 Track Your Progress:</h4>
                    <p className="step-text text-ecogreen">
                      A handy progress bar shows you how close you are to reaching
                      the next level.
                    </p>
                  </div>
                  
                  <div className="step-item">
                    <h4 className="step-title text-ecogreen">🌲 Plant Your Trees:</h4>
                    <p className="step-text text-ecogreen">
                      Once you reach a new level, the number of trees you can
                      plant will be displayed next to the tree icon. Simply access
                      the Ecovest virtual forest to plant your well-deserved
                      trees!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Unlock Section */}
      <section className="unlock-section py-5 position-relative">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <img className="logo-unlock img-fluid mb-5" alt="Logo" src="/assets/images/ecovestonboarding/logo-1.svg" />
              <h2 className="unlock-title text-ecogreen mb-4">Unlock Your Eco-Power</h2>
              <h3 className="unlock-subtitle text-ecogreen-light mb-5">in 4 Steps</h3>
              
              <div className="carousel-container mb-5">
                <Carousel property1="default" />
              </div>
              
              <BtnEcovest
                stateProp="one-default"
                text="Sign Up & Join the Movement!"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer bg-ecogreen-dark py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-4 mb-md-0">
              <img className="logo-footer img-fluid mb-3" alt="Logo" src="/assets/images/ecovestonboarding/logo-2.svg" />
              <p className="footer-text text-white">
                Lorem ipsum dolor sit amet consectetur. Viverra suscipit senectus
                lorem facilis facilisi iaculis potenti massa euismod accumsan. Dictum
                pharetra
              </p>
            </div>
            <div className="col-md-4 mb-4 mb-md-0">
              {/* Spacer for middle column if needed */}
            </div>
            <div className="col-md-4">
              <div className="contact-info">
                <h4 className="contact-title text-white mb-4">Contact Us</h4>
                <p className="contact-detail text-white mb-2">2035, Sousse , Sousse</p>
                <p className="contact-detail text-white mb-2">info@gmail.com</p>
                <p className="contact-detail text-white mb-4">+212 55 564 654</p>
                
                <div className="social-media d-flex gap-3">
                  <i className="fa-brands fa-square-facebook text-white fs-4"></i>
                  <i className="fa-brands fa-linkedin text-white fs-4"></i>
                  <i className="fa-brands fa-square-google-plus text-white fs-4"></i>
                </div>
              </div>
            </div>
          </div>
          
          <div className="row mt-5">
            <div className="col-12">
              <hr className="footer-divider border-ecogreen-light" />
              
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center pt-3">
                <p className="copyright text-white mb-2 mb-md-0">@ 2024 All rights reserved</p>
                <p className="legal-links text-white">Condition of use & Privacy Policy</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      </div>
    </div>
  );
};

export default EcovestOnboarding;